<script setup lang="ts">
import InterviewTemplate from '~/components/templates/InterviewTemplate/InterviewTemplate.vue';

const route = useRoute();
const id = computed(() => {
  const id = parseInterviewId(route.params.id as string);
  if (id == null) {
    throw createError({ statusCode: 404 });
  }
  return id;
});
</script>

<template>
  <InterviewTemplate :interview-id="id" />
</template>

<style module lang="scss"></style>
